module.exports = "<main> <div class=c-error-page> <h1 class=c-error-page__status-code>{{$ctrl.statusCode}}</h1> <h3 class=c-error-page__error>{{$ctrl.error}}</h3> </div> </main>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/error/views/http.error.html
// module id = 1041
// module chunks = 0